module.exports = __webpack_public_path__ + "img/img_level_8.ded3c69b.png";